import React from "react";
import PropTypes from "prop-types";
import { Notebook } from "@learningblocks/simulations/shared-components";
import { DesignChapterContentBlock } from "./DesignChapterContentBlock";

export function DesignSectionContent(props) {
  const onSelectMenu = () => props.goToSection(props.nextMenuValue);
  return (
    <>
      <Notebook.IndexBlock className="book_index">
        <Notebook.Header className="book_index_header">
          <Notebook.TitleBlock
            className="index-titleBlock"
            title={props.title}
            text={props.description}
            ariaLabel="Lab notebook secton heading."
          />
        </Notebook.Header>
        <Notebook.DesignSectionMenu
          className="book_index_designChapter"
          onSelect={onSelectMenu}
          title={props.currentMenu.title}
          number={props.currentMenu.number}
          menuList={props.menuList}
          onClickInfo={props.onClickInfo}
        />
        <DesignChapterContentBlock />
      </Notebook.IndexBlock>
    </>
  );
}

DesignSectionContent.propTypes = {
  /**
   * Details of currently active menu in menu list
   */
  currentMenu: PropTypes.shape({
    /**
     * Index of menu
     */
    number: PropTypes.number,
    /**
     * Title of menu
     */
    title: PropTypes.string,
    /**
     * Value of menu
     */
    value: PropTypes.string,
  }),
  /**
   * Description to be displayed in Notebook Header
   */
  description: PropTypes.string,
  /**
   * Function to go to next section
   */
  goToSection: PropTypes.func,
  /**
   * Function to set new isNotebookVisible value
   */
  setNotebookVisible: PropTypes.func,
  /**
   * Title of the Content to display at header
   */
  title: PropTypes.string,
  /**
   * Value for next-in-line menu
   */
  nextMenuValue: PropTypes.oneOf([
    "CONTEXT",
    "TECHNIQUES",
    "DESIGN",
    "PROBLEM_SOLVING",
    "RESULTS",
    "REFLECTION",
    "TROUBLESHOOTING",
    "NONE",
  ]),
  /**
   * function to invoke on clicking info icon on Notebook section menu
   */
  onClickInfo: PropTypes.func,
  /**
   * List of Menu Items
   */
  menuList: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Title to display in  menu
       */
      title: PropTypes.string.isRequired,
      /**
       * Boolean specifying if menu is selected
       */
      current: PropTypes.bool.isRequired,
      /**
       * Index number of menu
       */
      number: PropTypes.number.isRequired,
      /**
       * Unique string value of the menu
       */
      value: PropTypes.string.isRequired,
      /**
       * Boolean set when section is visited
       */
      visited: PropTypes.bool.isRequired,
    })
  ),
};

DesignSectionContent.defaultProps = {};
